<template>
  <div class="support page">
    <SiteHeader/>
    <main>
      <h1>Support</h1>
      <h2>Get Help</h2>
      <p>Contact us at <a href="mailto:insights@ranker.com" target="_blank" rel="noopener noreferrer">insights@ranker.com</a>
      </p>
      <p>Trainings are available for clients that subscribe to Premium</p>
      <h2>Guides</h2>
      <p><a href="https://blog.ranker.com/s/ranker_insights_premium_user_guide_setting_started.pdf" target="_blank"
            rel="noopener noreferrer">Quick Start Guide ></a></p>
      <h2>More Information</h2>
      <p><a href="https://blog.ranker.com/insight-scoop" target="_blank" rel="noopener noreferrer">Insight Scoop ></a>
      </p>
      <p>Interesting stories, industry trends, white papers, and more. All powered by Ranker data.</p>
    </main>
    <SiteFooter/>
  </div>
</template>

<script>
import SiteHeader from '@/components/layout/SiteHeader';
import SiteFooter from '@/components/layout/SiteFooter';

export default {
  name: 'SupportPage',
  components: {
    SiteHeader,
    SiteFooter
  }
};
</script>

<style lang="postcss">
.support {

  p {
    font-size: 17px;
    line-height: 20px;
    margin-bottom: 18px;
  }

  h1 {
    font-weight: 900;
    font-size: 30px;
    line-height: 35px;
  }

  h2 {
    font-weight: 900;
    font-size: 25px;
    line-height: 29px;
    margin-top: 50px;
    margin-bottom: 20px;
  }

  a {
    @apply font-bold;
  }
}
</style>